import {MetricGroupDto, VisualizationTypeDto} from '../layers/metric-layer';

// Configuration
export class VisualizationItem {
    value: VisualizationType;
    label: string;
    disabled?: boolean = true;
    children?: Array<VisualizationItem> = [];
}

// Other DTOs

// Enumerations
export enum VisualizationType {
    // Common types
    INDIVIDUAL = 'INDIVIDUAL', // i.e., individual asset
    LINE_CIRCUIT = 'LINE_CIRCUIT',
    LINE_PRID = 'LINE_PRID',
    LINE_IRID = 'LINE_IRID',
    INDIVIDUAL_WITH_SUBSTATION = 'INDIVIDUAL_WITH_SUBSTATION',
    LINE_CIRCUIT_WITH_SUBSTATION = 'LINE_CIRCUIT_WITH_SUBSTATION',
    LINE_PRID_WITH_SUBSTATION = 'LINE_PRID_WITH_SUBSTATION',
    LINE_IRID_WITH_SUBSTATION = 'LINE_IRID_WITH_SUBSTATION',
    METRIC_SUBSTATION = 'METRIC_SUBSTATION',
    LINE_TRANSMISSION = 'LINE_TRANSMISSION',
    // Custom grouping
    CUSTOM_GROUP = 'CUSTOM_GROUP',
    // Outage layer
    OUTAGE = 'OUTAGE',
}

// Labels
export const VisualizationTypeLabel = {
    [VisualizationType.INDIVIDUAL]: 'Individual',
    [VisualizationType.LINE_CIRCUIT]: 'Line Circuit',
    [VisualizationType.LINE_PRID]: 'Line PRID',
    [VisualizationType.LINE_IRID]: 'Line IRID',
    [VisualizationType.INDIVIDUAL_WITH_SUBSTATION]: 'Individual with Substation',
    [VisualizationType.LINE_CIRCUIT_WITH_SUBSTATION]: 'Line Circuit with Substation',
    [VisualizationType.LINE_PRID_WITH_SUBSTATION]: 'Line PRID with Substation',
    [VisualizationType.LINE_IRID_WITH_SUBSTATION]: 'Line IRID with Substation',
    [VisualizationType.METRIC_SUBSTATION]: 'Substation',
    [VisualizationType.LINE_TRANSMISSION]: 'Transmission Line',
    [VisualizationType.CUSTOM_GROUP]: 'Custom Group',
    [VisualizationType.OUTAGE]: 'Outage (by location)',
};

export enum VisualizationColorCode {
    OWNERSHIP = 'OWNERSHIP',
    STATUS = 'STATUS',
}

export class VisualizationTypeConfiguration {
    visualizationTypes: VisualizationTypeDto[];
    metricGroups: MetricGroupDto[];
}
